<template>
  <viewer-form :can-edit="isSuperVisor" @submit.prevent="toEditor">
    <text-browse-item label="会社名" :value="name" />
    <text-browse-item label="会社名（カナ）" :value="nameKana" />
    <licence-browse-item :type="licenceType" :number="licenceNumber" :update="licenceUpdate" />
    <postal-code-browse-item :value="postalCode" />
    <prefecture-browse-item :value="prefectureCode" />
    <text-browse-item label="市区町村" :value="address1" />
    <text-browse-item label="番地・建物など" :value="address2" />
    <text-browse-item label="電話番号" :value="tel" />
    <text-browse-item label="FAX番号" :value="fax" />
    <template #expansion-buttons-right>
      <router-button v-if="isSuperVisor" text="企業統合依頼" :to="{name: 'MergerRequestRegister'}" />
      <router-button text="社員一覧を表示" :to="{name: 'BrokerList'}" />
      <router-button text="発行依頼一覧を表示" :to="{name: 'IssuanceRequestList'}" />
    </template>
  </viewer-form>
</template>
<script>
import {mapState} from 'vuex'
import AddonLoadPageEvent from '@/mixin/AddonLoadPageEvent'
import ViewerForm from "@/views/templates/forms/ViewerForm";
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import LicenceBrowseItem from "@/views/molecules/browseItems/LicenceBrowseItem";
import PostalCodeBrowseItem from "@/views/molecules/browseItems/PostalCodeBrowseItem";
import PrefectureBrowseItem from "@/views/molecules/browseItems/PrefectureBrowseItem";
import RouterButton from '@/views/molecules/buttons/RouterButton';

export default {
  name: "BrokerageCompanyViewer",
  components: {
    ViewerForm,
    TextBrowseItem,
    LicenceBrowseItem,
    PostalCodeBrowseItem,
    PrefectureBrowseItem,
    RouterButton,
  },
  mixins: [AddonLoadPageEvent],
  computed: {
    ...mapState('brokerage_company_form', {
      name: state => state.data.name,
      nameKana: state => state.data.name_kana,
      licenceType: state => state.data.licence_type,
      licenceNumber: state => state.data.licence_number,
      licenceUpdate: state => state.data.licence_update,
      postalCode: state => state.data.postal_code,
      prefectureCode: state => state.data.prefecture_code,
      address1: state => state.data.address1,
      address2: state => state.data.address2,
      tel: state => state.data.tel,
      fax: state => state.data.fax,
    }),
    ...mapState('account', {
      isSuperVisor: state => state.is_supervisor,
    }),
  },
  methods: {
    loadPage() {
      return this.$store.dispatch('brokerage_company_form/load').then(() => {
        this.$root.showFlashMessage();
      }).catch(() => this.$root.failApi());
    },
    toEditor() {
      this.$router.push({name: "BrokerageCompanyEditor"});
    },
  }
}
</script>
